import React from "react";
import { getPQRValue, getColumnClasses } from "./pqrDataUtils";
import { pqrStyles } from "./pqrStyles";

const PQRGasTable = ({ pdf, type = "Groove" }) => {
  const isOverlay = type === "Overlay";
  const { colwidth, col1Class, col2Class, col3Class } = getColumnClasses(pdf,"gas");

  return (
    <>
      <div style={pqrStyles.group}>
        <div className="PQRbasemetal">GAS(QW- 408)</div>
      </div>
      <div style={pqrStyles.container}>
        <table id="table" className="PQRTable2" cellSpacing="0" style={{ width: "570px" }}>
          <tbody>
            {isOverlay ? (
              <tr className="PQRtrhide PQR_noleft PQR_Botm">
                <th className="PQRfillerMetalth PQR_border PQR_Botm" style={{ width: "27%" }}>
                  <div className="PQRgroup">
                    <div className="PQRlcorner">Sheilding:Gas{"(%Comp)"}&FlowRate{"(I/min)"}</div>
                  </div>
                </th>
                <td className={col1Class} style={{ width: colwidth }}>
                  {getPQRValue(pdf[1]?.PQRD_Gas_ShieldingType)} {" & "} {getPQRValue(pdf[1]?.PQRD_Gas_ShieldingFlowRate)}
                </td>
                <td className={col2Class} style={{ width: colwidth }}>
                  {getPQRValue(pdf[2]?.PQRD_Gas_ShieldingType)} {" & "} {getPQRValue(pdf[2]?.PQRD_Gas_ShieldingFlowRate)}
                </td>
                <td className={col3Class} style={{ width: colwidth }}>
                  {getPQRValue(pdf[3]?.PQRD_Gas_ShieldingType)} {" & "} {getPQRValue(pdf[3]?.PQRD_Gas_ShieldingFlowRate)}
                </td>
              </tr>
            ) : (
              <>
                <tr className="PQRtrhide PQR_Toprt">
                  <th className="PQRfillerMetalth PQR_noBotm" style={{ width: "27%" }}>
                    <div className="PQRgroup">
                      <div className="PQRlcorner">Sheilding:Gas{"(%Comp)"}&FlowRate{"(I/min)"}</div>
                    </div>
                  </th>
                  <td className={col1Class} style={{ width: colwidth }}>
                    {getPQRValue(pdf[1]?.PQRD_Gas_ShieldingType)} {" & "} {getPQRValue(pdf[1]?.PQRD_Gas_ShieldingFlowRate)}
                  </td>
                  <td className={col2Class} style={{ width: colwidth }}>
                    {getPQRValue(pdf[2]?.PQRD_Gas_ShieldingType)} {" & "} {getPQRValue(pdf[2]?.PQRD_Gas_ShieldingFlowRate)}
                  </td>
                  <td className={col3Class} style={{ width: colwidth }}>
                    {getPQRValue(pdf[3]?.PQRD_Gas_ShieldingType)} {" & "} {getPQRValue(pdf[3]?.PQRD_Gas_ShieldingFlowRate)}
                  </td>
                </tr>
                <tr className="WPStrhide">
                  <th className="PQRfillerMetalth PQR_rt_lft" style={{ width: "27%" }}>
                    <div className="PQRgroup">
                      <div className="PQRlcorner">Trailing <div className="PQRrcorner" style={{ paddingLeft: "8px", float: "right" }}>:Gas{"(%Comp)"}&FlowRate{"(I/min)"}</div></div>
                    </div>
                  </th>
                  <td className={col1Class} style={{ width: colwidth }}>
                    {getPQRValue(pdf[1]?.PQRD_Gas_TrailingType)} {" & "} {getPQRValue(pdf[1]?.PQRD_Gas_TrailingFlowRate)}
                  </td>
                  <td className={col2Class} style={{ width: colwidth }}>
                    {getPQRValue(pdf[2]?.PQRD_Gas_TrailingType)} {" & "} {getPQRValue(pdf[2]?.PQRD_Gas_TrailingFlowRate)}
                  </td>
                  <td className={col3Class} style={{ width: colwidth }}>
                    {getPQRValue(pdf[3]?.PQRD_Gas_TrailingType)} {" & "} {getPQRValue(pdf[3]?.PQRD_Gas_TrailingFlowRate)}
                  </td>
                </tr>
                <tr className="WPStrhide" style={{ borderBottom: "1px solid black" }}>
                  <th className="PQRfillerMetalth PQR_rt_lft" style={{ width: "27%", borderBottom: "1px solid black" }}>
                    <div className="PQRgroup">
                      <div className="PQRlcorner">Backing{" "} <div className="PQRrcorner" style={{ paddingLeft: "6px", float: "right" }}> :Gas{"(%Comp)"}&FlowRate{"(I/min)"}</div></div>
                    </div>
                  </th>
                  <td className={col1Class} style={{ width: colwidth }}>
                    {getPQRValue(pdf[1]?.PQRD_Gas_BackingType)}{" & "} {getPQRValue(pdf[1]?.PQRD_Gas_BackingFlowRate)}
                  </td>
                  <td className={col2Class} style={{ width: colwidth }}>
                    {getPQRValue(pdf[2]?.PQRD_Gas_BackingType)}{" & "} {getPQRValue(pdf[2]?.PQRD_Gas_BackingFlowRate)}
                  </td>
                  <td className={col3Class} style={{ width: colwidth }}>
                    {getPQRValue(pdf[3]?.PQRD_Gas_BackingType)}{" & "} {getPQRValue(pdf[3]?.PQRD_Gas_BackingFlowRate)}
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PQRGasTable;